import { useEffect, useState, useRef } from 'react';

interface LoadingSpinnerProps {
  visible: boolean;
}

export function LoadingSpinner({ visible }: LoadingSpinnerProps) {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const rafRef = useRef<number>();

  useEffect(() => {
    if (!visible) return;

    const handleMove = (e: MouseEvent) => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(() => {
        setPos({ x: e.clientX, y: e.clientY });
      });
    };

    document.body.style.cursor = 'none';
    window.addEventListener('mousemove', handleMove);

    return () => {
      document.body.style.cursor = '';
      window.removeEventListener('mousemove', handleMove);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <svg
      className="cursor-spinner"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      style={{ left: pos.x, top: pos.y }}
    >
      <circle
        cx="18"
        cy="18"
        r="16"
        fill="none"
        stroke="hsl(var(--accent))"
        strokeWidth="1"
        strokeDasharray="80 20"
      />
    </svg>
  );
}
